<div class="container-fluid">
  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Counselling Presentation List</h2>
      </li>
      <li class="dropdown m-l-20">
        <label for="search-input"><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" type="text" class="browser-default search-field"
               (keyup)='applyFilter($event)' [(ngModel)]="searchText" aria-label="Search box" #input>
      </li>
    </ul>
    <ul class="header-buttons mr-2">
      <li>
        <button mat-mini-fab color="primary" (click)="createNew()"
                permission="Counselling Presentation"
                [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]">
          <mat-icon class="col-white">add</mat-icon>
        </button>
      </li>
    </ul>
  </div>

  <div class="filter-section">
    <div class="row">
      <div class="col-md-3">
        <app-searchable-select
          class="w-100"
          [options]="centres$ | async"
          [multiple]="true"
          [hideSelectAllOption]="false"
          [(selectedValue)]="filterCentre"
          [displayKey]="'centreName'"
          [valueKey]="'centreName'"
          [label]="'Filter by Centre'"
          [placeholder]="'Enter Centres Name to search'"
          (selectionChange)="onCentreSelection($event)"
        ></app-searchable-select>
      </div>
      <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Enter a date range</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [(ngModel)]="start" placeholder="Start date">
            <input matEndDate [(ngModel)]="end" placeholder="End date">
          </mat-date-range-input>
          <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>

      <div class="col-md-5 d-flex align-items-center gap-2">
        <button mat-raised-button color="primary" (click)="applyAdvancedFilter()">
          <mat-icon>filter_list</mat-icon>
          Apply Filter
        </button>
        <button mat-raised-button color="warn" (click)="clearFilters()">
          <mat-icon>clear</mat-icon>
          Clear
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="loadingService.loading$ | async" class="loading-indicator">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <div class="responsive_table">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2 w-100">
      <!-- No. Column -->
      <ng-container matColumnDef="no">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> No.</th>
        <td mat-cell *matCellDef="let i = index"> {{ i + 1 }} </td>
      </ng-container>

      <!-- Centre Name Column -->
      <ng-container matColumnDef="centreName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre Name</th>
        <td mat-cell *matCellDef="let element"> {{ element.centreName }} </td>
      </ng-container>

      <!-- Date Range Column -->
      <ng-container matColumnDef="dateRange">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date Range</th>
        <td mat-cell
            *matCellDef="let element"> {{ formatDateRange(element.startDate, element.endDate) }} </td>
      </ng-container>

      <!-- Created By Column -->
      <ng-container matColumnDef="createdBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Created By</th>
        <td mat-cell *matCellDef="let element"> {{ element.createdBy }} </td>
      </ng-container>

      <!-- Created At Column -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Created At</th>
        <td mat-cell *matCellDef="let element"> {{ formatDate(element.createdAt) }} </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button color="primary" (click)="viewPresentation(element)"
                  matTooltip="View Presentation"
                  permission="Counselling Presentation"
                  [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]">
            <mat-icon>visibility</mat-icon>
          </button>
          <button mat-icon-button color="accent" (click)="editPresentation(element)"
                  matTooltip="Edit Presentation"
                  permission="Counselling Presentation"
                  [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="deletePresentation(element)"
                  matTooltip="Delete Presentation"
                  permission="Counselling Presentation"
                  [permissionTypes]="[PermissionType.ALL, PermissionType.ARCHIVE]">
            <mat-icon>delete</mat-icon>
          </button>
          <button mat-icon-button (click)="duplicatePresentation(element)"
                  matTooltip="Duplicate Presentation"
                  permission="Counselling Presentation"
                  [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]">
            <mat-icon>content_copy</mat-icon>
          </button>
          <button mat-icon-button (click)="exportToExcel(element)"
                  matTooltip="Export to Excel"
                  permission="Counselling Presentation"
                  [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]">
            <mat-icon>cloud_download</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <!-- Row shown when there is no data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="6">No data matching the filter "{{input.value}}"</td>
      </tr>
    </table>
  </div>

  <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
</div>
